export const errorMessages = {
    uniqueEmail: 'Email must be unique',
    wrongCredentials: 'Invalid email or password',
    noInternet: 'Vous semblez ne pas avoir de connection internet',
    wrongPassword: 'User current password is wrong',
    resetPasswordEmailNotFound: 'was not found',
    linkNotFound: 'not found',
    accountAlreadyActivated: 'This account is already activated',
    noLinkWithIdExist:'was found'
}